import template from './range-filter.component.html';

class RangeFilterController {
	constructor() {}

	$onInit() {
		this.min = this.attr.range && this.attr.range.min ? this.attr.range.min : null;

		this.max = this.attr.range && this.attr.range.max ? this.attr.range.max : null;

		if (this.attr.rawAttr.dataType === 'Integer') {
			this.pattern = /\d+/;
			this.inputType = 'number';
		} else {
			this.pattern = /.+/;
			this.inputType = 'text';
		}
	}
}

export const rangeFilterComponent = {
	template,
	controller: RangeFilterController,
	controllerAs: 'vm',
	bindings: {
		attr: '<'
	}
};
